<template>
  <v-list two-line subheader>
    <v-list-tile v-for="(ticket, i) in ticketsReaded" :key="i" avatar>
      <v-list-tile-content>
        <v-list-tile-title
          >Evento: {{ ticket.eventId || 'indefinido' }} - Ingresso: {{ ticket.code }}</v-list-tile-title
        >
        <v-list-tile-sub-title
          >Lido as {{ formatDate(ticket.readedAt) }} - Status: {{ ticket.status }}</v-list-tile-sub-title
        >
      </v-list-tile-content>
      <v-list-tile-action>
        <v-icon v-if="ticket.readed" color="primary lighten-1">sync</v-icon>
        <v-icon v-else color="error lighten-1">sync_disabled</v-icon>
      </v-list-tile-action>
    </v-list-tile>
  </v-list>
</template>

<script>
import moment from 'moment'
moment.locale('pt-br')

export default {
  created() {
    this.$store.dispatch('setCurrentPage', 'Histórico de validações')
  },
  computed: {
    ticketsReaded() {
      return this.$store.getters.readed
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format('h:mm:ss a')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/validation/ValidationHistory.vue